import { useMemo } from 'react';
import { QuestionProps } from 'src/types/questionnaire.types';
import DateTimePicker from '../../../../components/kit/date-time-picker/DateTimePicker';
import Text from '../../../../components/kit/text/Text';
import { getPreviousDate } from 'src/app/utils/calendar.utils';

export const DateTimeSelectionQuestion = ({
  question,
  handleSelectAnswer,
  stepNumber,
  selectedOption = undefined,
}: QuestionProps) => {
  const onSelect = (answer: Date) =>
    handleSelectAnswer({ ...question, date: answer }, stepNumber);
  const disabledBefore = useMemo(() => getPreviousDate(new Date()), []);

  return (
    <>
      <Text weight='bold' style={{ paddingTop: '26px', paddingBottom: '12px' }}>
        When is your appointment?
      </Text>
      <DateTimePicker
        showTimePicker
        minDate={disabledBefore}
        selectedDate={selectedOption ? (selectedOption as Date) : undefined}
        handleSelectDateTime={onSelect}
      />
    </>
  );
};
